module.exports = __webpack_public_path__ + "static/media/Butterfly_2_small.ac3cea13.png";